// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_gw-3";
export var flatBottomCorners = "_gw-5";
export var productImage = "_gw-0";
export var quantityContainer = "_gw-2";
export var quantityHeader = "_gw-6";
export var tooltip = "_gw-1";
export var wrapAndEllipsesOverflow = "_gw-4";